import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import "./index.css";
import { App } from "./App";
import { CommercePlatform } from "@spscommerce/services";
import { AuthService, RedirectService, InviteService } from "./utils";
import * as url from "./utils/url";
import { localize } from "@spscommerce/i18n";

const platform = new CommercePlatform();

var urlToParse = window.location.href;
if (url.hasKeyValue(url.parseUrlSearch(urlToParse), "motherlode", "true")) {
    document.body.classList.add("motherlode");
}

platform.getEnvironment().then(async (env) => {
    Sentry.init({
        dsn: "https://2b8977db2a5f475d9d2354fd7b2bcd31@o85353.ingest.sentry.io/5594440",
        autoSessionTracking: true,
        integrations: [new Integrations.BrowserTracing()],
        environment: env + "-CP-AUTH-REACT",
        tracesSampleRate: 0,
    });
    const authService = new AuthService(env, platform);
    const redirectService = new RedirectService();
    const inviteService = new InviteService(env);

    localize({
        debug: false,
        keySeparator: false,
        translationPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`,
    });

    ReactDOM.render(
        <React.StrictMode>
            <Suspense fallback={<div></div>}>
                <App
                    {...{
                        env,
                        platform,
                        authService,
                        redirectService,
                        inviteService,
                    }}
                />
            </Suspense>
        </React.StrictMode>,
        document.getElementById("root")
    );
});
